import { useEffect, useState } from 'react'

export const useIsTouchDevice = () => {
  const [hasTouchScreen, setHasTouchScreen] = useState(false)
  const [lastPointerEventWasTouch, setLastPointerEventWasTouch] =
    useState(false)

  useEffect(() => {
    setHasTouchScreen(window.matchMedia('(pointer: coarse)').matches)
  }, [window])

  useEffect(() => {
    //Alternative using pointer events
    document.addEventListener('pointerdown', updateFromPointerEvent)
    return () =>
      document.removeEventListener('pointerdown', updateFromPointerEvent)
  }, [document])

  const updateFromPointerEvent = (event: PointerEvent) => {
    if (event.pointerType === 'mouse') {
      setLastPointerEventWasTouch(false)
    } else if (event.pointerType === 'touch') {
      setLastPointerEventWasTouch(true)
    } else if (event.pointerType === 'pen') {
      setLastPointerEventWasTouch(true)
    }
  }

  return { hasTouchScreen, lastPointerEventWasTouch }
}
